import { useTranslation } from 'react-i18next';
import type { ProjectFundingStatus, ProjectFundingAccount } from '../types';

export const projectFundingRequirementKey = (account: ProjectFundingAccount) =>
  (account.startedMilestoneCount ?? 0) > 0
    ? (account.upcomingMilestoneCount ?? 0) > 0 ? 'projectFunding.account.requirementStarted' : 'projectFunding.account.requirementStartedOnly'
    : 'projectFunding.account.requirement';

/** Compact explanation shared by the folded account and deposit dialog. */
export function ProjectFundingRequirement({ account }: { account: NonNullable<ProjectFundingStatus['account']> }) {
  const { t, i18n } = useTranslation();
  const money = (amountOre: number) => new Intl.NumberFormat(i18n.language === 'en' ? 'en-GB' : 'sv-SE', {
    style: 'currency', currency: 'SEK', maximumFractionDigits: 2
  }).format(amountOre / 100);

  return <div className="text-explain" data-testid="project-funding-requirement">
    {account.remainingMilestoneCount === 0 ? <p className="mb-0">{t('projectFunding.account.finished')}</p> : <>
      <p className="mb-1">{t(projectFundingRequirementKey(account), { count: account.startedMilestoneCount || account.milestoneIds.length, amount: money(account.requiredAmountOre) })}</p>
      <p className="mb-0">{t(account.fulfilled ? 'projectFunding.account.fulfilled' : 'projectFunding.account.missing', { amount: money(account.missingAmountOre) })} {t('projectFunding.account.depositsIncluded')}</p>
    </>}
  </div>;
}
